<div class="input-group flex-nowrap">
  <select class="form-select currency-select input-field" [ngModel]="configService.selectedCurrencySubject | async" (ngModelChange)="configService.selectedCurrencySubject.next($event)">
    <option *ngFor="let currency of ratesService.currencies" [ngValue]="currency" class="currency-select-option">{{ currency.toUpperCase() }}</option>
  </select>
  <label class="input-group-text currency-select-rate-label hide-on-smaller-screens">
    1 {{(statsService.ticker$ | async)?.toUpperCase()}} ≈ {{rateForCurrencyFormatted | async}}
  </label>
</div>
